import { FC } from 'react';

import dataRoomGlobeSmallIcon from '../../../../assets/images/data-room-activity/data-room-globe-small.svg';
import { Tag, TagVariant } from '../../../../components/tag/index';

/**
 * Which data room a row or an event belongs to: the room's globe and its name. 22px tall as the
 * design draws it: Figma keeps the border inside the box, so its 2px by 8px padding is 1px by 7px
 * here, beside the border.
 */
export const DataRoomTag: FC<{ name: string }> = ({ name }) => (
  <Tag
    className="max-w-full px-[7px] py-px text-gray-600"
    icon={<img alt="" className="size-4 shrink-0" src={dataRoomGlobeSmallIcon} />}
    title={<span className="truncate">{name}</span>}
    variant={TagVariant.WHITE}
  />
);
